module.exports = __webpack_public_path__ + "aa1a1f40f614b6e9f85ee28281b26a3d.svg";